<template>
    <div>
        <vm-text-field
            class="mt-4"
            variant="outlined"
            label="Course Schema Id"
            v-model.number="props.tileserverConfig.courseSchemaId"
            type="number"
        />
        <vm-text-field
            class="mt-4"
            variant="outlined"
            label="Course Name"
            v-model="props.tileserverConfig.courseName"
        />

        <vm-text-field
            class="mt-4"
            variant="outlined"
            label="Key"
            v-model="props.tileserverConfig.key"
        />
        <vm-text-field
            class="mt-4"
            variant="outlined"
            label="Mbtiles"
            v-model="props.tileserverConfig.mbtiles"
        />
        <vm-text-field
            class="mt-4"
            variant="outlined"
            label="Display Name"
            v-model="props.tileserverConfig.displayName"
        />
        <vm-text-field
            class="mt-4"
            variant="outlined"
            label="Description"
            v-model="props.tileserverConfig.description"
        />
        <vm-text-field
            class="mt-4"
            variant="outlined"
            label="Mosaic Order"
            v-model.number="props.tileserverConfig.mosaicOrder"
            type="number"
        />

        <vm-switch
            class="mt-4 mb-4"
            label="Is Pinzone Mosaic"
            v-model="props.tileserverConfig.isPinzoneMosaic"
        />

        <vm-switch
            class="mt-4 mb-4"
            label="Is Player App Mosaic"
            v-model="props.tileserverConfig.isPlayerAppMosaic"
        />

        <div class="button-container">
            <vm-button
                class="mr-2"
                variant="text"
                primaryColor="var(--triadic2-600)"
                @click="closeCallback"
            >
                CANCEL
            </vm-button>
            <vm-button
                class="mr-2"
                primaryColor="var(--triadic2-600)"
                @click="saveCallback"
            >
                SAVE
            </vm-button>
        </div>
    </div>
</template>

<script lang="ts">
// vue
import { defineComponent } from 'vue';

export default defineComponent({
    props: ['tileserverConfig', 'saveCallback', 'closeCallback'],
    setup(props: any) {
        return {
            props,
        };
    },
});
</script>

<style scoped>
.button-container {
    display: flex;
    justify-content: right;
}
</style>
